<div class="row operateurContainer">

    <div class="col-2 d-flex justify-content-center align-items-center">

      
        <button (click)="selectOptionStatut('=')" class="operateur mr-3" [ngClass]="{ 'active':filterEcheancier.operateur_status_echeanciers === '=' }">
          <fa-icon  [icon]="fa['faEquals']"></fa-icon>
      </button>
      <button (click)="selectOptionStatut('!=')"  class="operateur" [ngClass]="{ 'active': filterEcheancier.operateur_status_echeanciers=== '!=' }">
          <fa-icon  [icon]="fa['faNotEqual']"></fa-icon>
      </button>
        </div>

   
    <div class="col-10 example-full-width">
        <mat-form-field class="example-full-width w-100">
          <mat-label>Status</mat-label>
          <mat-chip-list #chipList>
              <mat-chip *ngFor="let status of ListStatus" [selectable]="selectablee" [removable]="removablee" (removed)="removeStatus(status)" (removed)="EmitFilterEcheancier()">
                  {{status}}
                  <i matChipRemove *ngIf="removablee" class="fa fa-times" aria-hidden="true"></i>
                  <!-- <fa-icon matChipRemove *ngIf="removable" style="color: gray;" [icon]="fa['faTimes']"></fa-icon> -->
              </mat-chip>
              <input (click)="EmitFilterEcheancier()" placeholder="Selectionner statut..." #statusInput 
              [formControl]="StatusFromCtrl" [matAutocomplete]="autoo" [matChipInputFor]="chipList" [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
          </mat-chip-list>
          <mat-autocomplete #autoo="matAutocomplete" (optionSelected)="selectedStatus($event)">
              <mat-option *ngFor="let status of filteredStatus | async" [value]="status.id">
                  {{status.libelle}}
              </mat-option>
          </mat-autocomplete>
      </mat-form-field>
    </div>
</div>







<div class="row operateurContainer">
    <div class="col-2 d-flex justify-content-center align-items-center">

      
        <button (click)="selectOptionMotif('=')" class="operateur mr-3" [ngClass]="{ 'active':filterEcheancier.operateur_motif === '=' }">
          <fa-icon  [icon]="fa['faEquals']"></fa-icon>
      </button>
      <button (click)="selectOptionMotif('!=')"  class="operateur" [ngClass]="{ 'active': filterEcheancier.operateur_motif=== '!=' }">
          <fa-icon  [icon]="fa['faNotEqual']"></fa-icon>
      </button>
        </div>
    
    <div class="col-10">
        <mat-form-field class="example-full-width w-100">
          <mat-label>Motif</mat-label>
          <mat-chip-list #chipsList>
              <mat-chip *ngFor="let motif of ListMotif" [selectable]="selectable" [removable]="removable"
               (removed)="removeMotif(motif)" (removed)="EmitFilterEcheancier()">
                  {{motif}}
                  <i matChipRemove *ngIf="removable" class="fa fa-times" aria-hidden="true"></i>

                  <!-- <fa-icon matChipRemove *ngIf="removable" style="color: gray;" [icon]="fa['faTimes']"></fa-icon> -->
              </mat-chip>
              <input placeholder="Selectionner Motif..." #MotifInput 
              [formControl]="MotifFromCtrl" [matAutocomplete]="auto" [matChipInputFor]="chipsList"
               [matChipInputSeparatorKeyCodes]="separatorKeysCodes">
          </mat-chip-list>
          <mat-autocomplete #auto="matAutocomplete" (optionSelected)="selectedMotif($event)">
              <mat-option *ngFor="let motif of filteredMotif | async" [value]="motif.id">
                  {{motif.libelle}}
              </mat-option>
          </mat-autocomplete>
      </mat-form-field>
    </div>
    </div>
    <div class="col-12">
        <mat-form-field class="w-100 fontsDate" >
        <mat-date-range-input [rangePicker]="pickerDC">
          <input matStartDate (change)="EmitFilterEcheancier()" (click)="openDatePeriod()" readonly [(ngModel)]="date_debut_periode" placeholder="Date de période du" />
          <input matEndDate (change)="EmitFilterEcheancier()" (click)="openDatePeriod()" readonly [(ngModel)]="date_fin_periode" placeholder="à" />

      </mat-date-range-input>
      <mat-datepicker-toggle class="m-0 p-0" matPrefix [for]="pickerDC">    <mat-icon matDatepickerToggleIcon>
        <img src="assets/icons/calendar.svg" > 
      </mat-icon></mat-datepicker-toggle>
      <img  class="remouveDate" matSuffix  (click)="clearDatePeriod()" src="assets/icons/delete-left.svg">
      <mat-date-range-picker (closed)="EmitFilterEcheancier()" [calendarHeaderComponent]="rangeDatePeriod" #pickerDC></mat-date-range-picker>
        </mat-form-field>
      </div>



 

  